import { useCallback } from 'react'
import {
  ApiGetWithToken,
	ApiDeleteWithToken,
	ApiPatchWithToken,
	ApiPostWithToken,
	useApiFetch,
	useApiPost
} from 'shared/api'
import {
	searchsSenmoniApi,
	searchsSenmoniApiBy
} from 'interface/endpoints'
import {
	SearchsSenmoniFormData,
  SearchsSenmoniResult,
  SearchsSenmoniResultList
} from './types'

export * from './types'

export const useListSearchsSenmoni = (
  searchId?: number | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
      if (!searchId) return null
      return ApiGetWithToken<SearchsSenmoniResultList>(
        apiAccess,
        searchsSenmoniApi(searchId, "/list"),
        cancelToken
  		)
    },
		[searchId]
	)
)

export const useGetSearchsSenmoni = (
  searchId?: number | null,
	searchsSenmoniId?: number | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
      if (!searchId || !searchsSenmoniId) return null
      return ApiGetWithToken<SearchsSenmoniResult>(
        apiAccess,
        searchsSenmoniApiBy(searchId, searchsSenmoniId),
        cancelToken
  		)
    },
		[searchId, searchsSenmoniId]
	)
)

export const usePostSearchsSenmoni = (
  searchId: number, 
	callback?: {
    onPosted?: (result: SearchsSenmoniResult) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<SearchsSenmoniFormData, SearchsSenmoniResult>(
	useCallback(
		(apiAccess, cancelToken, form, webSocketId) => {
			return ApiPostWithToken(
				apiAccess,
        searchsSenmoniApi(searchId),
				form,
				cancelToken,
				webSocketId
			)
		},
		[searchId]
	),
	useCallback(
		(result) => {
			if (callback?.onPosted) callback.onPosted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useEditSearchsSenmoni = (
  searchId: number,
	searchsSenmoniId: number, 
	callback?: {
    onEditted?: (result: SearchsSenmoniResult) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<SearchsSenmoniFormData, SearchsSenmoniResult>(
	useCallback(
		(apiAccess, cancelToken, form, webSocketId) => {
			return ApiPatchWithToken(
				apiAccess,
        searchsSenmoniApiBy(searchId, searchsSenmoniId),
				form,
				cancelToken,
				webSocketId
			)
		},
		[searchId, searchsSenmoniId]
	),
	useCallback(
		(result) => {
			if (callback?.onEditted) callback.onEditted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useSortSearchsSenmoni = (
	searchId: number,
  callback?: {
    onPosted?: (result: SearchsSenmoniResult) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<number[], SearchsSenmoniResult>(
	useCallback(
		(apiAccess, cancelToken, ids, webSocketId) => {
			return ApiPostWithToken(
				apiAccess,
        searchsSenmoniApi(searchId, "/sort"),
				ids,
				cancelToken,
				webSocketId
			)
		},
		[searchId]
	),
	useCallback(
		(result) => {
			if (callback?.onPosted) callback.onPosted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useRemoveSearchsSenmoni = (
  searchId: number, 
	callback?: {
    onDeleted?: (searchsSenmoniId: number) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<number, number>(
	useCallback(
		(apiAccess, cancelToken, searchsSenmoniId, webSocketId) => {
			return ApiDeleteWithToken(
				apiAccess,
        searchsSenmoniApiBy(searchId, searchsSenmoniId),
				cancelToken,
				webSocketId
			)
		},
		[searchId]
	),
	useCallback(
		(result) => {
			if (callback?.onDeleted) callback.onDeleted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)
